import {KecPath, Service, Version, source} from './constants';

export const getProjects = {
    basePath: KecPath,
    params: {
        Action: 'GetAccountProjectList',
        Version: '2015-11-01',
        source,
        Service: 'iam'
    },
    method: 'get'
};

export const changeProjects = {
    basePath: KecPath,
    params: {
        Action: 'UpdateInstanceProjectId',
        Version: '2015-11-01',
        source,
        Service: 'iam'
    },
    method: 'post'
};